<template>
    <div class="packageChoice"  v-if="numberObj">
        <van-nav-bar
                title="套餐选择"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        <div class="packageChoice-tabNumber">
            <div class="packageChoice-tabNumber-title"><van-icon name="phone-o"/><span>{{numberObj.serialNumber}}</span></div>
            <div class="packageChoice-tabNumber-desc">
                您选择的号码 {{numberObj.serialNumber}}
                {{',需预存 '+numberObj.preDeposit/100+' 元'}}
                {{numberObj.baseAmount == null?'':(',每月保底消费 '+numberObj.baseAmount/100+' 元')}}</div>
            <!-- <van-cell :title="numberObj.title" style="font-weight:100;" icon="phone-o" :label="numberObj.label" /> -->
        </div>
        <div class="packageChoice-pack"  v-if="packageList != null  && packageList.length > 0">
            <div class="packageChoice-pack-list">
                <van-sidebar v-model="activeKey">
                    <van-sidebar-item
                    style="color:#20A0FF;"
                    @click='packageChoiceClick'
                        v-for="(item,index) in packageList" 
                        :key="index"
                        :title="item.packageName">
                    </van-sidebar-item>
                </van-sidebar>
            </div>
            <div class="packageChoice-pack-info">
                <van-panel title="套餐内容项">
                    <div style="padding:10px 0px;">{{packageChoiceDetail != null ?packageChoiceDetail.packageDesc:''}}</div>
                </van-panel>
            </div>
            <!-- <div class="packageChoice-pack-info">
                <van-cell-group>
                    <van-cell 
                    :value="packageChoiceDetail != null ?packageChoiceDetail.packageDesc:''"
                    style="padding:10px 0px;"
                    title-class='packageChoice-pack-info-cell-title'
                    value-class='packageChoice-pack-info-cell-value'/>
                </van-cell-group>
            </div> -->
        </div>
        <div class='packageChoice-btn'>
            <van-button type="primary" size="large" @click="submitData" :loading='submitLoading' loading-text='正在提交...'>确认</van-button>
        </div>
    </div>
</template>

<script>
  import {setAesString,getAesString} from "../../config/date";

export default {
    name: 'packageChoice',
    data(){
        return{
            submitLoading:false,
            numberObj:null,
            activeKey:0,
            packageChoiceDetail:null,
            packageList:[]
        }
    },
    created(){
        this.numberObj = sessionStorage.getItem(setAesString("numberObj"));
        if(this.numberObj == null){
            this.$dialog.alert({
                message: '请先返回上一步选择中意号码'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/index'
                });
            });
            return;
        }
        this.numberObj = JSON.parse(getAesString(this.numberObj));

        this.queryPackageList();
    },
    methods: {
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        packageChoiceClick(index){
            this.packageChoiceDetail = this.packageList[index];
        },
        submitData(){
            if(this.numberObj == null){
                this.$toast({
                    message: '请返回上一步选择中意的号码!',
                    icon: 'fail'
                });
                return;
            }
            if(this.packageChoiceDetail == null){
                this.$toast({
                    message: '请选择需要的套餐!',
                    icon: 'fail'
                });
                return;
            }
            sessionStorage.setItem(setAesString("packageObj"),setAesString(JSON.stringify(this.packageChoiceDetail)));
            //提交数据
            this.$router.push({
                path:'/userInfo'
            });
        },
        queryPackageList(){

            var formdata={
                ...this.page,
                service : "user.qryChoicePackage",
                sid: this.numberObj.sid
            }

            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.packageList = res;
                if(this.packageList != null && this.packageList.length > 0){
                    this.packageChoiceDetail = this.packageList[0];
                }
            },(res)=>{
                this.$toast({
                    message: res.errorMsg,
                    icon: 'fail'
                });
            });
        }

    }
}
</script>

<style lang="less">
@main-green rgb(7, 193, 96);
@main-blue: #20A0FF;
@main-white: #ffffff;


.packageChoice{
    height: 100%;
    &-tabNumber{
        background-color:@main-white;
        padding: 20px;
        margin-top: 47px;
        margin-bottom: 10px;
        &-title{
            padding: 5px;
            text-align: center;
            font-size: 20px;
        }
        &-desc{
            font-size: 13px;
            font-weight: 400;
        }
    }

    &-pack{
        padding: 10px 0px;
        background-color: white;
        color:rgb(99, 104, 105);
        &-list{
            display: inline-table;
            width: 35%;
        }
        &-info{
            width: 65%;
            display: inline-table;
            &-cell-title{
                display: contents;
            }
            &-cell-value{
                display: contents;
            }
        }
    }

    &-btn{
        text-align: center;
        margin: 50px 10px;
    }
}


.van-sidebar-item{
    width: 120px;
} 

.van-sidebar-item .van-sidebar-item--select{
    background-color: #20A0FF
}



</style>
